import React, { Fragment } from 'react';
import { Paper, Typography } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import IconButton from '@mui/material/IconButton';
import { v4 as uuidv4 } from 'uuid';
import { useStateIfMounted } from 'use-state-if-mounted';
import {
    agregarFC_33Accion,
    actualizarFC_33Estatus,
    resetDataFC_33,
    actualizarFC_33SolicitudBorrador,
    agregarFC_33SolicitudBorrador,
    eliminarFC_33AnexoProductoBD,
    actualizarModoBorradorFC_33,
    actualizarModoCorrecionFC_33,
    actualizarFC_33PaginaActiva,
    ObtenerClientePorLogin33,
    obtenerContadorDeFechaFolio,
    enviarBorradorFC_33, ObtenerInstalacionesRelacionadas,
    actualizarFC_33Solicitud
} from '../../../redux/DucksBeneficiario/FC_33Ducks';
import { obtenerSolicitudesWithStatus } from '../../../redux/SolicitudesDucks';
import { obtenerClienteByIdLogin } from '../../../redux/DucksBeneficiario/ClienteDucks';
import BotonAtrasSiguienteComponent from '../../App/BotonAtrasSiguienteComponent';
import Tooltip from '@mui/material/Tooltip';
import TablaProducto from './TablaProducto';
import InfoBar from '../../App/InfoBar'
import TerminosYCondicionesComponent from '../../App/TerminosYCondicionesComponent';
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import moment from 'moment'
import SaveIcon from '@mui/icons-material/Save';
import FormatClearIcon from '@mui/icons-material/FormatClear';
import ToolBarPaginas from '../../App/ToolBarPaginas';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { actualizarLoadingApp_false, actualizarLoadingApp_true } from '../../../redux/AppDucks';
import estilos from './FormularioFC33BeneficiarioComponent.module.css';
import { Formik } from 'formik'
import ModalCamposObligatorios from '../../App/ModalCamposObligatorios';
const { useState, useEffect, useRef } = React;
import { ArchivoComponent } from '../../ArchivosComponents/ArchivoComponent';
import Collapsible from 'react-collapsible';
import DocumentacionFC_33Component from './DocumentacionFC_33Component';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function FormularioFC33BeneficiarioComponent(props) {

    const dispatch = useDispatch()
    const usuario = useSelector(store => store.Usuario)
    const currentUser = useSelector(store => store.Usuario.data)

    let dataLogin = useSelector(store => store.FC_33Solicitud.dataLogin)
    let dataCliente = useSelector(store => store.FC_33Solicitud.cliente)
    let marcas = useSelector(store => store.FC_33Solicitud.marcasCliente) //useSelector(store => store.Solicitudes.marcasCliente)
    let instalacionesCliente = useSelector(store => store.FC_33Solicitud.instalacionesCliente)
    let fc_33 = useSelector(store => store.FC_33Solicitud.fc_33)
    let fc_33Productos = useSelector(store => store.FC_33Solicitud.productos)
    let fc_33Map = useSelector(store => store.FC_33Solicitud.fc_33Map)
    let fc_33ProductosMap = useSelector(store => store.FC_33Solicitud.productosMap)
    let observacionesStatus = useSelector(store => store.FC_33Solicitud.observacionesStatus)
    const modoEdicionBorrador = useSelector(store => store.FC_33Solicitud.modoEdicionBorrador)
    const modoCorreccion = useSelector(store => store.FC_33Solicitud.modoCorreccion)
    let data = useSelector(store => store.FC_33Solicitud.data)

    let contadorFolio = useSelector(store => store.FC_33Solicitud.contadorDeFechaFolio)

    // let fc_33ProductosMap = useSelector(store => store.FC_33Solicitud.productosMap)
    const idUsuario = usuario.data.user[0].id
    var fechaHoy = moment().format('YYYY-MM-DD')
    const [fechasolicitud, setfechasolicitud] = useStateIfMounted(fechaHoy)
    const [alert, setAlert] = useStateIfMounted(false)
    const [errorAgregar, setErrorAgregar] = useStateIfMounted(false)
    const [exito, setExito] = useStateIfMounted(false)

    let [terminosYCondiciones, setTerminosYCondiciones] = useStateIfMounted(false)
    React.useEffect(() => {
        if (props.history.location.state) {
            setTerminosYCondiciones(props.history.location.state.terminosYCondiciones)
        }
    }, [props.history.location.state])

    React.useEffect(() => {
        let data = dispatch(ObtenerClientePorLogin33({ idlogin: usuario.data.user[0].id }))
    }, [])

    React.useEffect(() => {
        var año = moment().format('YY');
        let year = String(año)
        dispatch(obtenerContadorDeFechaFolio(year))
    }, [])

    const [productos, setProductos] = React.useState([])
    const filesFC_33 = useSelector(store => store.FC_33Solicitud.files)
    const filesProductosFC_33 = useSelector(store => store.FC_33Solicitud.filesProductos)
    // let fc_33ProductosMap = []

    const handdleProducto = (objectProducto) => {
        setProductos(prev => [...prev, objectProducto])
    }
    const handdleRemoveProductosPrev = async (objectProducto) => {
        if (objectProducto.data.idfc33_anexoproducto) {
            await dispatch(eliminarFC_33AnexoProductoBD(objectProducto.data.idfc33_anexoproducto))
        }
        const filtro = productos.filter(anexo => anexo.id !== objectProducto.data.id)
        setProductos(filtro)

    }
    const handdleEditProductosPrev = (paramsObjectProducto) => {
        const { ...objectProducto } = paramsObjectProducto
        if (fc_33ProductosMap.length > 0) {
            const filtro = productos.findIndex(anexo => anexo.idfc33_anexoproducto === objectProducto.id)
            let editar = { ...productos[Number(filtro)] }
            const filtroEliminar = productos.filter(anexo => anexo.idfc33_anexoproducto !== objectProducto.id)
            editar.contenidoalcoholico = objectProducto.contenidoalcoholico
            editar.numeroanalisis = objectProducto.numeroanalisis
            editar.numerocertificado = objectProducto.numerocertificado
            editar.marca = objectProducto.marca
            editar.numerolote = objectProducto.numerolote
            editar.contenidonetobotella = objectProducto.contenidonetobotella
            editar.numerobotellas = objectProducto.numerobotellas
            editar.tipoproducto = objectProducto.tipoproducto
            editar.numerocajas = objectProducto.numerocajas
            filtroEliminar.push(editar)
            setProductos(filtroEliminar)
        } else {
            const filtro = productos.findIndex(anexo => anexo.id === objectProducto.id)
            let editar = productos
            const newProductos = []
            for (const i in productos) {
                const { ...restProducto } = productos[i]
                newProductos.push(restProducto)
            }
            newProductos[Number(filtro)].contenidoalcoholico = objectProducto.contenidoalcoholico
            newProductos[Number(filtro)].numeroanalisis = objectProducto.numeroanalisis
            newProductos[Number(filtro)].numerocertificado = objectProducto.numerocertificado
            newProductos[Number(filtro)].marca = objectProducto.marca
            newProductos[Number(filtro)].numerolote = objectProducto.numerolote
            newProductos[Number(filtro)].contenidonetobotella = objectProducto.contenidonetobotella
            newProductos[Number(filtro)].numerobotellas = objectProducto.numerobotellas
            newProductos[Number(filtro)].tipoproducto = objectProducto.tipoproducto
            newProductos[Number(filtro)].numerocajas = objectProducto.numerocajas
            setProductos(newProductos)
        }
    }

    const [idfc33_solicitudenvasadonaciona, setidfc33_solicitudenvasadonaciona] = useStateIfMounted(0)
    const idfc33_solicitudenvasadonacionaRef = useRef(idfc33_solicitudenvasadonaciona)
    const idestatusdesolicitudes = 2
    const idlogin = idUsuario

    const store = useSelector(store => store)
    const [filesProductos, setFileProductos] = React.useState([])
    const handleResetAllPropertys = () => {

        setProductos([])
        setFile([])
        setFileProductos([])
        handleCloseModal()
        dispatch(resetDataFC_33())
    }
    React.useEffect(() => {
        if (filesFC_33?.data) {
            let newFiles = []
            for (const file of filesFC_33.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFile(newFiles)
        }

        if (filesProductosFC_33?.data) {
            let newFiles = []
            for (const file of filesProductosFC_33.data) {
                const { ...newFile } = file
                newFiles.push(newFile)
            }
            setFileProductos(newFiles)
        }

    }, [fc_33, data])

    const noActualizarBorrador = useRef(true)
    React.useEffect(() => {
        if (!(JSON.stringify({}) === JSON.stringify(data))) {
            fc_33 = data
        }
        if (!(JSON.stringify({}) == JSON.stringify(fc_33))) {
            if (fc_33Productos.data) {
                if (fc_33Productos.data.data) {
                    setProductos(fc_33Productos.data.data)
                } else {
                    setProductos(fc_33Productos.data)
                }
            }
        }
    }, [fc_33, data])

    const [functionResetForm, setFunctionResetForm] = React.useState()
    const [functionSubmitForm, setFunctionSubmitForm] = React.useState()

    const [openModal, setOpenModal] = React.useState(false);
    const [titleModal, setTitleModal] = React.useState('');
    const [bodyModal, setBodyModal] = React.useState('')
    const [accion, setAccion] = React.useState('')
    const [dataModal, setDataModal] = React.useState('')
    const handleOpenModal = (data) => {

        setTitleModal(data.title)
        setBodyModal(data.body)
        setAccion(data.accion)
        setOpenModal(true)
        setDataModal(data.data)
    }
    const handleCloseModal = () => {
        setTitleModal('')
        setBodyModal('')
        setAccion('')
        setOpenModal(false)
        setDataModal('')
    }


    const modalComponent = () => {
        return (
            <div>
                <Modal
                    open={openModal}
                    onClose={handleCloseModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <center>{titleModal}</center>
                        </Typography>
                        <Typography id="modal-modal-description" sx={{ mt: 2 }} component="h2">
                            <p className={`${estilos.bodyModal}`}>{bodyModal}</p>
                            <br /> <center><strong>¿Desea continuar?</strong></center>
                        </Typography>
                        <br />
                        <div className='row'>
                            <button className='btn btn-success' onClick={() => {
                                switch (accion) {
                                    case 'enviarSolicitudFC_33':
                                        activarBotonEnviarForm()
                                        functionSubmitForm.function()
                                        break;
                                    case 'guardarBorrador':
                                        guardarBorrador(dataModal)
                                        break;
                                    case 'actualizarBorrador':
                                        actualizarBorrador(dataModal)
                                        break;
                                    case 'reiniciarFormato':
                                        handleResetAllPropertys()
                                        functionResetForm.function()
                                        break;
                                    case 'enviarSolicitudBorradorFC_33':
                                        activarBotonEnviarBorrador()
                                        functionSubmitForm.function()
                                        break;
                                    case 'enviarCorreccion':
                                        activarBotonEnviarCorreciones()
                                        functionSubmitForm.function()
                                        break;
                                    default:
                                        break;
                                }
                            }
                            }>CONTINUAR</button>
                        </div>
                    </Box>
                </Modal>
            </div>
        )
    }
    let botonEnviarRegistro = false
    let botonEnviarBorrador = false
    const [botonEnviarCorrecciones, setBotonEnviarCorrecciones] = React.useState(false)

    const activarBotonEnviarForm = () => {
        botonEnviarRegistro = true
    }
    const activarBotonEnviarBorrador = () => {
        botonEnviarBorrador = true
    }
    const activarBotonEnviarCorreciones = () => {
        setBotonEnviarCorrecciones(true)
    }
    const botonEnviarSolicitudFC_33 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente deberá adjuntar la documentación 
            correspondiente para enviar la solicitud al personal de atencion al cliente.`,
            accion: 'enviarSolicitudFC_33'
        })
    }

    const botonEnviarBorradorFC_33 = async () => {
        handleOpenModal({
            title: `Advtertencia!`,
            body: `Está a punto de enviar su solicitud al personal de atencion al cliente, 
            ya no podrá seguir editando esta solicitud.`,
            accion: 'enviarBorrador'
        })
    }
    const botonGuardarComoBorrador = async (valores) => {
        if (modoEdicionBorrador) {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de actualizar este borrador de solicitud.
                Los archivos de la sección final no se guardarán, puesto que es un borrador del formulario.`,
                accion: 'actualizarBorrador',
                data: valores
            })
        } else {
            handleOpenModal({
                title: `¡Advertencia!`,
                body: `Está a punto de guardar esta solicitud en su apartado de borradores
                Los archivos de la sección final no se guardarán puesto que es un borrador del formulario`,
                accion: 'guardarBorrador',
                data: valores
            })
        }
    }
    const botonReiniciarFormato = () => {
        handleOpenModal({
            title: `Advtertencia!`,
            body: `Está a punto de reiniciar el formato, esta acción eliminará toda la información
                y no se podrá revertir.`,
            accion: 'reiniciarFormato'
        })
    }
    const botonEnviarCorreccionesFC_33 = async () => {
        handleOpenModal({
            title: `Advtertencia!`,
            body: `Está a punto de enviar las correcciones al personal de atención al cliente, 
            ya no podrá seguir corrigiendo esta solicitud.`,
            accion: 'enviarCorreccion'
        })
    }
    const botonEnviarSolicitudBorradorFC_33 = async () => {
        handleOpenModal({
            title: `¡Advertencia!`,
            body: `Está a punto de finalizar el formulario, posteriormente deberá adjuntar la documentación 
            correspondiente para enviar la solicitud al personal de atención al cliente.`,
            accion: 'enviarSolicitudBorradorFC_33'
        })
    }


    const botonRegistrarFC_33 = async (valores) => {
        //let exito = true
        await dispatch(actualizarLoadingApp_true())

        let fechaSolicitud = new Date(fechasolicitud).toISOString()
        let fechaVisita = new Date(valores.fechavisitapropuesta).toISOString()

        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio

        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))
        var añoFolio = moment().format('YY');
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 9999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio

        const solicitud = {
            fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente,
            maquilador: valores.maquilador, propia: valores.propia, numerosocio: Number(valores.numerosocio),
            resposableinstalaciones: valores.resposableinstalaciones,
            telefono: (valores.telefono + ''), correoelectronico: valores.correoelectronico,
            domicilioproducto: valores.domicilioproducto, entregahologramas: valores.entregahologramas,
            inspeccionenvasadonacional: true,
            emicioncertificadonomparaventan: true,
            fechavisitapropuesta: fechaVisita, informacionadicionalsobreactivi: valores.informacionadicionalsobreactivi,
            idestatusdesolicitudes: 7, idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, folio: consFolio,
            nombrecliente: dataCliente.nombrerazonsocial, tipoinstalacion: valores.tipoinstalacion
        }

        const objetoCompletoFC_33 = {
            solicitud,
            productos
        }
        const resultado = await dispatch(agregarFC_33Accion(objetoCompletoFC_33))

        handleResetAllPropertys()
        await dispatch(actualizarLoadingApp_false())

        if (resultado) {
            await dispatch(resetDataFC_33())
            functionResetForm.function()
            await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        }
    }
    const guardarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio


        let fechaSolicitud = new Date(fechasolicitud).toISOString()
        let fechaVisita = new Date(valores.fechavisitapropuesta).toISOString()
        var año = moment().format('YY');
        let year = String(año)
        const contadorFolios = await dispatch(obtenerContadorDeFechaFolio(year))

        var añoFolio = moment().format('YY');
        let consFolio = ''
        if (contadorFolios.payload >= 0 && contadorFolios.payload < 9) consFolio = 'FR-000' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 9 && contadorFolios.payload < 99) consFolio = 'FR-00' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 99 && contadorFolios.payload < 999) consFolio = 'FR-0' + (contadorFolios.payload + 1) + '/' + añoFolio
        if (contadorFolios.payload >= 999 && contadorFolios.payload < 9999) consFolio = 'FR-' + (contadorFolios.payload + 1) + '/' + añoFolio

        let idAduana = Number(valores.idaduanasalida)
        if (idAduana === 0) idAduana = null
        const solicitud = {
            fechasolicitud: fechaSolicitud, numerocliente: numeroDeCliente,
            maquilador: valores.maquilador, propia: valores.propia, numerosocio: Number(valores.numerosocio),
            resposableinstalaciones: valores.resposableinstalaciones,
            telefono: (valores.telefono + ''), correoelectronico: valores.correoelectronico,
            domicilioproducto: valores.domicilioproducto, entregahologramas: valores.entregahologramas,
            inspeccionenvasadonacional: true, emicioncertificadonomparaventan: true,
            fechavisitapropuesta: fechaVisita, informacionadicionalsobreactivi: valores.informacionadicionalsobreactivi,
            idestatusdesolicitudes: 1, idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, folio: consFolio,
            nombrecliente: dataCliente.nombrerazonsocial, tipoinstalacion: valores.tipoinstalacion
        }
        const objetoCompletoFC_33 = {
            solicitud,
            productos
        }
        const resultado = await dispatch(agregarFC_33SolicitudBorrador(objetoCompletoFC_33))

        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            await dispatch(resetDataFC_33())
            await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        } else {
        }
    }
    const actualizarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())

        let fechaSolicitud = new Date(fechasolicitud).toISOString()
        let fechaVisita = new Date(valores?.fechavisitapropuesta).toISOString()

        const solicitud = {
            idfc33_solicitudenvasadonaciona: data.idfc33_solicitudenvasadonaciona,//numerocliente: numeroDeCliente,
            maquilador: valores.maquilador, propia: valores.propia, numerosocio: Number(valores.numerosocio),
            fechasolicitud: fechaSolicitud, resposableinstalaciones: valores.resposableinstalaciones,
            telefono: (valores.telefono + ''), correoelectronico: valores.correoelectronico,
            domicilioproducto: valores.domicilioproducto, entregahologramas: valores.entregahologramas,
            inspeccionenvasadonacional: true,
            emicioncertificadonomparaventan: true,
            fechavisitapropuesta: fechaVisita, informacionadicionalsobreactivi: valores.informacionadicionalsobreactivi,
            idestatusdesolicitudes: 1, idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos,
            nombrecliente: dataCliente.nombrerazonsocial, tipoinstalacion: valores.tipoinstalacion
        }
        const objetoCompletoFC_33 = {
            solicitud,
            productos
        }
        const resultado = await dispatch(actualizarFC_33SolicitudBorrador(objetoCompletoFC_33))

        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            await dispatch(resetDataFC_33())
            await dispatch(obtenerSolicitudesWithStatus({ status: 1, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        } else {
        }
    }
    const enviarBorrador = async (valores) => {
        await dispatch(actualizarLoadingApp_true())

        const resCliente = await dispatch(obtenerClienteByIdLogin(currentUser.user[0].id))
        const numeroDeCliente = resCliente.payload?.cliente?.[0]?.numerosocio

        let fechaSolicitud = new Date(fechasolicitud).toISOString()
        let fechaVisita = new Date(valores?.fechavisitapropuesta).toISOString()

        const solicitud = {
            idfc33_solicitudenvasadonaciona: data.idfc33_solicitudenvasadonaciona,//numerocliente: numeroDeCliente,
            maquilador: valores.maquilador, propia: valores.propia, numerosocio: Number(valores.numerosocio),
            fechasolicitud: fechaSolicitud, resposableinstalaciones: valores.resposableinstalaciones,
            telefono: (valores.telefono + ''), correoelectronico: valores.correoelectronico,
            domicilioproducto: valores.domicilioproducto, entregahologramas: valores.entregahologramas,
            inspeccionenvasadonacional: true,
            emicioncertificadonomparaventan: true,
            fechavisitapropuesta: fechaVisita, informacionadicionalsobreactivi: valores.informacionadicionalsobreactivi,
            idestatusdesolicitudes: 7, idlogin, revisor: dataLogin.nombre + ' ' + dataLogin.apellidos,
            nombrecliente: dataCliente.nombrerazonsocial, tipoinstalacion: valores.tipoinstalacion
        }

        const objetoCompletoFC_33 = {
            solicitud,
            productos
        }
        const resultado = await dispatch(enviarBorradorFC_33(objetoCompletoFC_33))
        await dispatch(actualizarLoadingApp_false())
        if (resultado) {
            const idSolicitud = data.idfc33_solicitudcertificado
            const estatusNuevo = 7
            const idCliente = null //Se necesita obtener del cliente, a traves del login 
            const tablaFC_33 = 7
            const tabla = tablaFC_33
            await dispatch(actualizarFC_33Estatus(
                { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
            ))
            await dispatch(resetDataFC_33())
            functionResetForm.function()
            await dispatch(obtenerSolicitudesWithStatus({ status: 7, idLogin: currentUser.user[0].id }))
            props.history.push('/solicitudes')
        }
    }
    const enviarCorreccion = async (valores) => {
        await dispatch(actualizarLoadingApp_true())
        let fechaSolicitud = new Date(fechasolicitud)?.toISOString()
        let fechaVisita = new Date(valores.fechavisitapropuesta)?.toISOString()
        const solicitud = {
            idfc33_solicitudenvasadonaciona: data.idfc33_solicitudenvasadonaciona,
            fechasolicitud: fechaSolicitud, 
            entregahologramas: valores.entregahologramas,
            fechavisitapropuesta: fechaVisita,
            maquilador: valores.maquilador, propia: valores.propia, numerosocio: Number(valores.numerosocio),
            resposableinstalaciones: valores.resposableinstalaciones, telefono: (valores.telefono + ''), correoelectronico: valores.correoelectronico,
            domicilioproducto: valores.domicilioproducto, informacionadicionalsobreactivi: valores.informacionadicionalsobreactivi,
            idestatusdesolicitudes: 6, idlogin, emicioncertificadopromocion: valores.emicioncertificadopromocion,
            revisor: dataLogin.nombre + ' ' + dataLogin.apellidos, tipoinstalacion: valores.tipoinstalacion
        }
        const objetoCompletoFC_33 = {
            solicitud,
            productos,
            //files,
            filesProductos
        }
        await dispatch(actualizarFC_33Solicitud(objetoCompletoFC_33))
        const idSolicitud = data.idfc33_solicitudenvasadonaciona
        const estatusNuevo = 6
        const idCliente = null //Se necesita obtener del cliente, a traves del login 
        const tablaFC_33 = 7
        const tabla = tablaFC_33
        await dispatch(actualizarFC_33Estatus(
            { data: { tabla: tabla, idSolicitud: idSolicitud, estatus: estatusNuevo, idCliente: idCliente, folio: data.folio } }
        ))
        await dispatch(resetDataFC_33())
        handleResetAllPropertys()
        await dispatch(actualizarLoadingApp_false())
        props.history.push('/solicitudes')
    }
    const salirModoEdicionBorrador = async () => {
        dispatch(actualizarModoBorradorFC_33(false))
        dispatch(resetDataFC_33())
        handleResetAllPropertys()
    }
    const salirModoCorreccion = () => {
        dispatch(actualizarModoCorrecionFC_33(false))
        dispatch(resetDataFC_33())
        handleResetAllPropertys()
    }

    function comprobarEmail(correo) {
        let emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let isEmailAceptadoFlag = false;
        let isExtensionAceptadaFlag = false;
        if (!correo) return false
        if (correo.match(emailRegex)) {
            isEmailAceptadoFlag = true;
            isExtensionAceptadaFlag = true;
            if (isEmailAceptadoFlag === true && isExtensionAceptadaFlag === true) {
                return true
            } else {
                return false
            }
        } else {
            return false
        }
    }

    const [files, setFile] = React.useState([])
    const filesRef = React.useRef(files)
    let filesMap = useSelector(store => store.FC_33Solicitud.filesMap)
    const handdleFile = (objectFile) => {
        setFile(prev => [...prev, objectFile])
    }

    const handdleRemovePrev = (objectFile) => {
        if (objectFile) {
            const newFiles = files.map(file => {
                if (file.id === objectFile.id) {
                    file.file = objectFile.file
                    return (file)
                } else {
                    return (file)
                }
            })
            if (newFiles !== undefined) {
                setFile(newFiles)
            }
        }
    }
    const FilesGenerales = () => {
        return (
            <div>
                <Collapsible trigger="Documentación general" className='mb-3'>
                    <div className={`mb-3 ${estilos.divSoloBorderDocsNaranja}`}>
                        <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGOC'} tabla={"FC_33_anexos"} filesMap={filesMap}
                            textLabel={`Orden de compra: `} textoTooltip='Del importador o invitación a la feria o exposición en el extranjero.' />
                        <ArchivoComponent api={{ handdleFile, handdleRemovePrev, files }} id={'DGFP'} tabla={"FC_33_anexos"} filesMap={filesMap}
                            textLabel={`Factura o proforma: `} textoTooltip='En caso de que el producto se exporte con fines de promoción, entregar factura sin valor comercial.' />

                    </div>
                </Collapsible>
            </div>
        )
    }

    const [paginas, setPaginas] = useStateIfMounted([1, 2, 3, 4])
    const paginaActiva = useSelector(store => store.FC_33Solicitud.paginaActiva)
    const [nombresParaPaginas, setNombresParaPaginas] = useStateIfMounted(['Datos generales', 'Productos', 'Documentación'])
    const paginaSiguiente = async (valores) => {
        if (productos.length === 0 && nombresParaPaginas[paginaActiva - 1] === 'Productos') {
            settexto('o por lo menos un producto')
            setvalidacion(true)
        } else {
            const result = await validation(valores)
            if (JSON.stringify(result) !== '{}') {
                settexto('')
                setvalidacion(true)
            } else {
                dispatch(actualizarFC_33PaginaActiva(paginaActiva + 1))
            }
        }

    }
    const paginaAnterior = async () => {
        dispatch(actualizarFC_33PaginaActiva(paginaActiva - 1))
    }
    const [validacion, setvalidacion] = React.useState(false)
    const [texto, settexto] = React.useState('')
    const resetValores = (objectProducto) => {
        setvalidacion(objectProducto.validacion)
    }
    const validation = values => {
        let errores = {};
        const textoError = 'Campo obligratorio'

        if (paginaActiva === 1) {
            if (!values.fechavisitapropuesta) { errores.fechavisitapropuesta = textoError }
            if (!values.maquilador && !values.propia && (values.maquilador === false && values.propia === false)) {
                errores.tipoInstalacion = 'Seleccione el tipo de instalación'
            }
            if (values.maquilador === true) {
                if (!values.numerosocio) { errores.numerosocio = textoError }
            }

            if (!values.resposableinstalaciones) { errores.resposableinstalaciones = textoError }
            if (!values.correoelectronico) { errores.correoelectronico = textoError }
            else {
                let valido = comprobarEmail(values.correoelectronico)
                if (!valido) errores.correoelectronico = 'Verifica la estructura de tu correo electrónico'
            }
            if (!values.telefono) { errores.telefono = textoError }
            else if ((values.telefono + '').length !== 10) errores.telefono = 'Debe contener 10 digitos'
            if (!values.domicilioproducto) { errores.domicilioproducto = textoError }
            else {
                let longitudDomicilio = values.domicilioproducto.split(',')
                if (longitudDomicilio.length !== 8) { errores.domicilioproducto = "Ingresar el domicilio completo separado por una coma, (calle,número interior,número exterior,colonia,localidad,código postal,municipio,estado)" }
            }

        }
        return errores;
    }
    const setDataResponsable = (data) => {
        let cadena = data.split('/')
        for (let instalaciones of instalacionesCliente) {
            for (let dato of instalaciones.informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente) {
                if (dato.nombreresponsable === cadena[1] && dato.idresponsabledeinstalacioncliente === Number(cadena[0])) {
                    const telefono = dato.telefono
                    const correoelectronico = dato.correoelectronico
                    const domicilioproducto = instalaciones.informaciongeneralinstalacioncliente.calle + "," +
                        instalaciones.informaciongeneralinstalacioncliente.numerointerior + "," +
                        instalaciones.informaciongeneralinstalacioncliente.numeroexterior + "," +
                        instalaciones.informaciongeneralinstalacioncliente.colonia + "," +
                        instalaciones.informaciongeneralinstalacioncliente.localidad + "," +
                        instalaciones.informaciongeneralinstalacioncliente.codigopostal + "," +
                        instalaciones.informaciongeneralinstalacioncliente.municipio + "," +
                        instalaciones.informaciongeneralinstalacioncliente.estado
                    return { telefono, correoelectronico, domicilioproducto }
                }
            }
        }
        return ''
    }
    let relacionesCliente = useSelector(store => store.FC_33Solicitud.relacionesCliente)
    let instalacionesRelacionadas = useSelector(store => store.FC_33Solicitud.instalacionesRelacionadas)
    let [activeinstalaciones, setActiveInstalaciones] = React.useState(true)
    let [numSocioEncontrado, setNumSocioEncontrado] = React.useState(false)
    const buscarSocio = async (numerosocio) => {
        const filtro = relacionesCliente.filter(relacion => relacion.productor === numerosocio || relacion.envasado === numerosocio)

        if (filtro.length > 0) {
            let instalacionesRelacionadas = await dispatch(ObtenerInstalacionesRelacionadas(numerosocio))
            setActiveInstalaciones(false)
            setNumSocioEncontrado(false)
        } else {
            setNumSocioEncontrado(true)
            setActiveInstalaciones(true)
        }
    }
    let [resposableRelacionados, setResposableRelacionados] = React.useState([])
    let [activeresponsable, setActiveResponsable] = React.useState(true)
    const setDomicilio = (target) => {

        let instalaciones = { ...instalacionesRelacionadas }
        for (let dato in instalaciones) {
            if (instalaciones[dato].informaciongeneralinstalacioncliente.alias === target) {
                //const telefono = dato.telefono
                setResposableRelacionados(instalaciones[dato].informaciongeneralinstalacioncliente.responsablesdeinstalacioncliente)
                //const correoelectronico = dato.correoelectronico
                const domicilioproducto = instalaciones[dato].informaciongeneralinstalacioncliente.calle + "," +
                    instalaciones[dato].informaciongeneralinstalacioncliente.numerointerior + "," +
                    instalaciones[dato].informaciongeneralinstalacioncliente.numeroexterior + "," +
                    instalaciones[dato].informaciongeneralinstalacioncliente.colonia + "," +
                    instalaciones[dato].informaciongeneralinstalacioncliente.localidad + "," +
                    instalaciones[dato].informaciongeneralinstalacioncliente.municipio + "," +
                    instalaciones[dato].informaciongeneralinstalacioncliente.estado + "," +
                    instalaciones[dato].informaciongeneralinstalacioncliente.codigopostal
                setActiveResponsable(false)
                return domicilioproducto
            }
        }
        return ''
    }
    const setResponsables = (target) => {
        for (let dato in resposableRelacionados) {
            if (resposableRelacionados[dato].nombreresponsable === target) {
                const telefono = resposableRelacionados[dato].telefono + ''
                const correoelectronico = resposableRelacionados[dato].correoelectronico
                return { telefono, correoelectronico }
            }
        }
        return ''
    }
    return (
        <Fragment>
            <Formik
                initialValues={
                    fc_33
                }
                validate={validation}
                onSubmit={(valores) => {
                    if (botonEnviarRegistro) {
                        botonRegistrarFC_33(valores)
                    }
                    if (botonEnviarBorrador) {
                        enviarBorrador(valores)
                    }
                    if (botonEnviarCorrecciones) {
                        enviarCorreccion(valores)
                    }
                }}
            >
                {({ values, handleChange, handleSubmit, handleBlur, errors, touched, resetForm, submitForm, setValues }) => (
                    <form onSubmit={(e) => handleSubmit(e)}>

                        <div className='container2'>
                            <div className='row mt-3'>
                                <div className='row'>
                                    <div className="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-12 marginsitoTop">
                                        <InfoBar nombreSolicitud={'Solicitud de certificado de venta nacional'} />

                                        {modoEdicionBorrador &&
                                            <div className='d-grid gap-2'>
                                                <button className='badge btn-danger mt-1 mb-1'
                                                    onClick={salirModoEdicionBorrador}>Salir modo edición</button>
                                            </div>
                                        }
                                        {/*modoCorreccion &&
                                            <div className='row text-center '>
                                                <span className="">
                                                    <div className=' gap-2'>
                                                        <button className='btn badge bg-danger text-white mb-1'
                                                            onClick={salirModoCorreccion}>Salir del modo corrección</button>
                                                    </div>
                                                </span>
                                            </div>
                                    */}
                                    </div>
                                    {!modoCorreccion &&
                                        <div className="col-xs-12 col-sm-12 col-md-5 col-lg-2 col-xl-2 marginsitoTop">
                                            <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                                aria-label="Guardar cambios" aria-haspopup="true" onClick={() => { botonGuardarComoBorrador(values), setFunctionResetForm({ function: resetForm }) }}
                                            >
                                                <SaveIcon />
                                                {
                                                    modoEdicionBorrador ? (
                                                        <div className="badge text-dark textoModal text-center">
                                                            Guardar cambios en borrador
                                                        </div>) : (
                                                        <div className="badge text-dark textoModal text-center">
                                                            Guardar como borrador
                                                        </div>
                                                    )
                                                }
                                            </IconButton>
                                        </div>
                                    }
                                    <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 text-center">
                                        <h1></h1>
                                    </div>
                                    {!modoCorreccion &&
                                        <div className="col-xs-12 col-sm-12 col-md-2 col-lg-1 col-xl-1 text-center marginsitoTop">
                                            <Fragment>
                                                <IconButton sx={{ color: '#c88b3e' }} size="large" edge="end"
                                                    aria-label="Reiniciar formato" aria-haspopup="true" color="error" onClick={() =>
                                                        botonReiniciarFormato()}
                                                >
                                                    <FormatClearIcon />
                                                    <div className="badge text-dark textoNormalbadge text-dark textoModal text-center">Reiniciar Formato </div>
                                                </IconButton>
                                            </Fragment>
                                        </div>
                                    }
                                </div>
                            </div>

                            {
                                paginaActiva === 1 ?
                                    (
                                        <Fragment>
                                            {
                                                modoCorreccion &&
                                                <div className='text-center'>
                                                    {
                                                        observacionesStatus.observacionesGeneral !== 0 ?
                                                            <h6><p style={{ color: 'red' }}><strong>Este apartado tiene observaciones</strong></p></h6>
                                                            :
                                                            <h6><p style={{ color: 'green' }}><strong>Este apartado no tuvo observaciones</strong></p></h6>
                                                    }
                                                </div>
                                            }
                                            <div className='row'>
                                                <h6 className={`text-center ${estilos.labelNaranja}`}>SERVICIO SOLICITADO</h6>
                                            </div>
                                            <div className='row align-items-center'>
                                                <div className='row justify-content-start'>

                                                    <div className={`row  ${estilos.divSoloBorderNaranja}`}>
                                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                            <input className={`form-check-input me-1 ${fc_33Map.entregahologramascheck !== undefined ? (
                                                                fc_33Map?.entregahologramascheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                type="checkbox" id="checkbox1"
                                                                align='left'
                                                                name="entregahologramas"
                                                                value={values.entregahologramas}
                                                                checked={values.entregahologramas}
                                                                onChange={handleChange}
                                                                onBlur={handleBlur}
                                                            />


                                                            <Tooltip title={`Los hologramas se entregaran después de 24 horas de aceptación de la solicitud, previa constatación
                                                    del cumplimiento del producto con el apartado 4.3 de la NOM-070, en vigor.
                                                    En caso de que el producto ya cuente con los hologramas no seleccionar este recuadro.`} arrow>
                                                                <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                                    Entrega de hologramas
                                                                </label>
                                                            </Tooltip><br />
                                                            <span className='text-danger'>{fc_33Map?.entregahologramas}</span>
                                                            {touched.entregahologramas && errors.entregahologramas && <div className="text-danger">{errors.entregahologramas}</div>}
                                                        </div>
                                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                            <input className={`form-check-input me-1 ${fc_33Map.emicioncertificadonomparaventancheck !== undefined ? (
                                                                fc_33Map?.emicioncertificadonomparaventancheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                type="checkbox" value="" id="" checked={true}
                                                                //onChange={e => setemicioncertificadonomparaventan(e.target.checked)} 
                                                                name="emicioncertificadonomparaventan"
                                                            />
                                                            <span className='text-danger'>{fc_33Map?.emicioncertificadonomparaventan}</span>
                                                            <Tooltip title={`El certificado se emitirá una vez que se reciba el Dictamen de Cumplimiento
                                                    con la NOM de la Unidad de inspección (previa inspección del envasado y del
                                                    holograma de certificación).`} arrow>
                                                                <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                                    Emisión del certificado
                                                                </label>
                                                            </Tooltip><br />
                                                            <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                                NOM para venta nacional
                                                            </label>
                                                        </div>
                                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                            <br />
                                                            <input className={`form-check-input me-1 ${fc_33Map.inspeccionenvasadonacionalcheck !== undefined ? (
                                                                fc_33Map?.inspeccionenvasadonacionalcheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                type="checkbox" value="" id="" checked={true}
                                                                name="inspeccionenvasadonacional"
                                                            //onChange={e => setinspeccionenvasadonacional(e.target.checked)} 
                                                            />

                                                            <span className='text-danger'>{fc_33Map?.inspeccionenvasadonacional}</span>
                                                            <label className="form-check-label me-5" htmlFor="flexCheckChecked">
                                                                Inspección durante el envasado nacional
                                                            </label>

                                                        </div>
                                                        <div className='col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                                            <br />
                                                            <div className="form-floating mb-3">

                                                                <input type="date" className={`form-control ${fc_33Map.fechavisitapropuestacheck !== undefined ? (
                                                                    fc_33Map?.fechavisitapropuestacheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    // value={fechavisitapropuesta} onChange={e => setfechavisitapropuesta(e.target.value)} 
                                                                    id="" placeholder='Fecha propuesta' min={fechaHoy}
                                                                    name="fechavisitapropuesta"
                                                                    value={values.fechavisitapropuesta}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <label htmlFor='floatingInput'>Fecha de visita propuesta</label>
                                                                <span className='text-danger'>{fc_33Map?.fechavisitapropuesta}</span>
                                                                {touched.fechavisitapropuesta && errors.fechavisitapropuesta && <div className="text-danger">{errors.fechavisitapropuesta}</div>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div><br />
                                            <div className='row'>
                                                <h6 className={`text-center ${estilos.labelNaranja}`}>DOMICILIO DONDE SE ENCUENTRA EL PRODUCTO</h6>
                                            </div>
                                            <div className='row justify-content-start'>


                                                <div className='col-xs-12 col-sm-12 col-md-3 col-xl-3 col-xxl-3'>
                                                    <label htmlFor='floatingInput'>¿Tipo de instalación?</label>
                                                </div>
                                                <div className='col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2'>
                                                    <input className={`form-check-input me-1 ${fc_33Map.maquiladorcheck !== undefined ? (
                                                        fc_33Map?.maquiladorcheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                        checked={values.maquilador} id='maquilador'
                                                        name="maquilador"
                                                        onChange={e => {
                                                            const { ...newValues } = values
                                                            newValues.maquilador = e.target.checked
                                                            newValues.propia = !e.target.checked
                                                            newValues.resposableinstalaciones = ''
                                                            newValues.correoelectronico = ''
                                                            newValues.telefono = ''
                                                            newValues.domicilioproducto = ''
                                                            newValues.numerosocio = ''
                                                            setValues(newValues)
                                                        }}
                                                        onBlur={handleBlur}
                                                    />
                                                    <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                        Maquilador
                                                    </label>
                                                </div>
                                                <div className='col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2'>
                                                    <input className={`form-check-input me-1 ${fc_33Map.propiacheck !== undefined ? (
                                                        fc_33Map?.propiacheck ? 'inputDenegado' : 'inputValidado') : ('')}`} type="checkbox"
                                                        checked={values.propia} id='propia'
                                                        name="propia"
                                                        onChange={e => {
                                                            const { ...newValues } = values
                                                            newValues.propia = e.target.checked
                                                            newValues.maquilador = !e.target.checked
                                                            newValues.resposableinstalaciones = ''
                                                            newValues.correoelectronico = ''
                                                            newValues.telefono = ''
                                                            newValues.domicilioproducto = ''
                                                            newValues.numerosocio = ''
                                                            setValues(newValues)
                                                        }}
                                                        onBlur={handleBlur}
                                                    />
                                                    <label className="form-check-label me-1" htmlFor="flexCheckChecked">
                                                        Propia
                                                    </label>
                                                </div>
                                                {
                                                    values.maquilador &&
                                                    <Fragment>
                                                        <div className='col-xs-12 col-sm-12 col-md-3 col-xl-3 col-xxl-3'></div>
                                                        <div className='col-xs-12 col-sm-12 col-md-5 col-xl-5 col-xxl-5'>
                                                            <div className="form-floating mb-3">
                                                                <input type="number" className={`form-control ${fc_33Map.numerosociocheck !== undefined ? (
                                                                    fc_33Map?.numerosociocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    id="floatingInput" placeholder='ejemplo@gmail.com'
                                                                    // value={numerosocio} 
                                                                    // onChange={e => { e.target.value.length <= 4 ? (setNumeroSocio(e.target.valueAsNumber)) : '' }}
                                                                    name="numerosocio"
                                                                    value={values.numerosocio}
                                                                    onChange={e => {
                                                                        if (e.target.value.length < 5) {
                                                                            const { ...newValues } = values
                                                                            newValues.numerosocio = e.target.value
                                                                            newValues.domicilioproducto = ''
                                                                            newValues.telefono = ''
                                                                            newValues.correoelectronico = ''
                                                                            newValues.resposableinstalaciones = ''
                                                                            newValues.tipoinstalacion = ''
                                                                            setResposableRelacionados([])
                                                                            setActiveInstalaciones(true)
                                                                            setActiveResponsable(true)
                                                                            setValues(newValues)
                                                                        }
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                    onWheel={event => event.currentTarget.blur()}
                                                                />
                                                                <label htmlFor='floatingInput'>Número de socio</label>
                                                                <span className='text-danger'>{fc_33Map?.numerosociocheck ? fc_33Map?.numerosocio : ''}</span>
                                                                {
                                                                    numSocioEncontrado && <span className='text-danger'>Número de socio no encontrado en sus relaciones</span>
                                                                }
                                                                {touched.numerosocio && errors.numerosocio && <div className="text-danger">{errors.numerosocio}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-xs-12 col-sm-12 col-md-1 col-xl-1 col-xxl-1'>
                                                            <button type="submit" className={'btn btn-success'} onClick={() => { buscarSocio(values.numerosocio) }} disabled={fc_33Map.numerosociocheck == false ? true : false}>Buscar</button>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <div className="form-floating mb-3">
                                                                <select className={`form-select ${fc_33Map.domicilioproductocheck !== undefined ? (
                                                                    fc_33Map?.domicilioproductocheck ? 'inputDenegado' : 'inputValidado') : fc_33Map.numerosociocheck !== undefined ? (
                                                                        fc_33Map?.numerosociocheck ? 'inputDenegado' : 'inputValidado') : ''}`}

                                                                    name="tipoinstalacion"
                                                                    value={values.tipoinstalacion}
                                                                    onChange={e => {
                                                                        const result = setDomicilio(e.target.value)
                                                                        const { ...newValues } = values
                                                                        newValues.tipoinstalacion = e.target.value
                                                                        if (result !== '') {
                                                                            newValues.domicilioproducto = result
                                                                        } else {
                                                                            newValues.domicilioproducto = result
                                                                            newValues.telefono = ''
                                                                            newValues.correoelectronico = ''
                                                                            newValues.resposableinstalaciones = ''
                                                                            setActiveResponsable(true)
                                                                        }
                                                                        setValues(newValues)
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                    disabled={activeinstalaciones}
                                                                >
                                                                    <option value="">Seleccione una instalación</option>
                                                                    {
                                                                        instalacionesRelacionadas?.map((opcion, index) => (
                                                                            <option value={`${opcion.informaciongeneralinstalacioncliente.alias}`}>
                                                                                {`${opcion.idtipoanexo === 1 ? 'Unidad Producción: ' + opcion.informaciongeneralinstalacioncliente.alias : opcion.idtipoanexo === 2 ? 'Unidad de Envasado: ' + opcion.informaciongeneralinstalacioncliente.alias : opcion.idtipoanexo === 3 ? 'Unidad Almacen: ' + opcion.informaciongeneralinstalacioncliente.alias : ''}`}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                                <label htmlFor='floatingInput'>Tipo de instalación</label>
                                                                <span className='text-danger'>{fc_33Map?.numerosociocheck ? fc_33Map?.numerosocio : ''}</span>
                                                                {touched.tipoinstalacion && errors.tipoinstalacion && <div className="text-danger">{errors.tipoinstalacion}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            <div className="form-floating mb-3">
                                                                <select className={`form-select ${fc_33Map.resposableinstalacionescheck !== undefined ?
                                                                    (fc_33Map?.resposableinstalacionescheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}

                                                                    name="resposableinstalaciones"
                                                                    value={values.resposableinstalaciones}
                                                                    onChange={e => {
                                                                        const result = setResponsables(e.target.value)
                                                                        const { ...newValues } = values
                                                                        newValues.resposableinstalaciones = e.target.value
                                                                        if (result !== '') {
                                                                            newValues.correoelectronico = result.correoelectronico
                                                                            newValues.telefono = result.telefono
                                                                        } else {
                                                                            newValues.correoelectronico = ''
                                                                            newValues.telefono = ''
                                                                        }
                                                                        setValues(newValues)
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                    disabled={activeresponsable}
                                                                >
                                                                    <option value="">Seleccione un responsable</option>
                                                                    {
                                                                        resposableRelacionados.map((opcion, index) => (
                                                                            <option value={`${opcion.nombreresponsable}`} >{`${opcion.nombreresponsable}`}</option>
                                                                        ))
                                                                    }
                                                                </select>
                                                                <label htmlFor='floatingInput'>Responsable de instalacion</label>
                                                                <span className='text-danger'>{fc_33Map?.resposableinstalacionescheck === true ? fc_33Map?.resposableinstalaciones : ''}</span>
                                                                {touched.resposableinstalaciones && errors.resposableinstalaciones && <div className="text-danger">{errors.resposableinstalaciones}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-xs-12 col-sm-12 col-md-3 col-xl-3 col-xxl-3'>
                                                            <div className="form-floating mb-3">
                                                                <input type="text" className={`form-control ${fc_33Map.resposableinstalacionescheck !== undefined ?
                                                                    (fc_33Map?.resposableinstalacionescheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    id="floatingInput" placeholder='ejemplo@gmail.com'
                                                                    // value={correoelectronico} onChange={e => setcorreoelectronico(e.target.value)}
                                                                    name="correoelectronico"
                                                                    value={values.correoelectronico}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <label htmlFor='floatingInput'>Correo electrónico</label>
                                                                <span className='text-danger'>{fc_33Map?.correoelectronicocheck ? fc_33Map?.correoelectronico : ''}</span>
                                                                {touched.correoelectronico && errors.correoelectronico && <div className="text-danger">{errors.correoelectronico}</div>}
                                                            </div>
                                                        </div>

                                                        <div className='col-xs-12 col-sm-12 col-md-3 col-xl-3 col-xxl-3'>
                                                            <div className="form-floating mb-3">
                                                                <input type="number" min='0' className={`form-control ${fc_33Map.resposableinstalacionescheck !== undefined ?
                                                                    (fc_33Map?.resposableinstalacionescheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    id="floatingInput" placeholder='Telefono'
                                                                    // value={telefono} onChange={e => settelefono(e.target.value)}
                                                                    name="telefono"
                                                                    value={values.telefono}
                                                                    onChange={e => {
                                                                        if (e.target.value.length < 11) {
                                                                            const { ...newValues } = values
                                                                            newValues.telefono = e.target.value
                                                                            setValues(newValues)
                                                                        }
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                    onWheel={event => event.currentTarget.blur()}
                                                                />
                                                                <label htmlFor='floatingInput'>Teléfono</label>
                                                                <span className='text-danger'>{fc_33Map?.telefonocheck ? fc_33Map?.telefono : ''}</span>
                                                                {touched.telefono && errors.telefono && <div className="text-danger">{errors.telefono}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-xs-12 col-sm-12 col-md-12 col-xl-12 col-xxl-12'>
                                                            <div className="form-floating mb-3">
                                                                <input type="text" className={`form-control ${fc_33Map.domicilioproductocheck !== undefined ? (
                                                                    fc_33Map?.domicilioproductocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Domicilio Completo'
                                                                    name="domicilioproducto"
                                                                    value={values.domicilioproducto}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <label htmlFor='floatingInput'>Domicilio completo</label>
                                                                <span className='text-danger'>{fc_33Map?.domicilioproductocheck ? fc_33Map?.domicilioproducto : ''}</span>
                                                                {touched.domicilioproducto && errors.domicilioproducto && <div className="text-danger">{errors.domicilioproducto}</div>}
                                                            </div>
                                                        </div>
                                                    </Fragment>
                                                }
                                                {
                                                    values.propia &&
                                                    <Fragment>
                                                        <div className='col-md-6'>
                                                            <br />
                                                            <div className="form-floating mb-3">
                                                                <select className={`form-select ${fc_33Map.resposableinstalacionescheck !== undefined ?
                                                                    (fc_33Map?.resposableinstalacionescheck === true ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    // value={resposableinstalaciones}
                                                                    // onChange={e => setResponsable(e.target.value)}

                                                                    name="resposableinstalaciones"
                                                                    value={values.resposableinstalaciones}
                                                                    onChange={e => {
                                                                        const result = setDataResponsable(e.target.value)
                                                                        const { ...newValues } = values
                                                                        newValues.resposableinstalaciones = e.target.value
                                                                        if (result !== '') {
                                                                            newValues.correoelectronico = result.correoelectronico
                                                                            newValues.telefono = result.telefono
                                                                            newValues.domicilioproducto = result.domicilioproducto
                                                                        }
                                                                        setValues(newValues)
                                                                    }}
                                                                    onBlur={handleBlur}
                                                                >
                                                                    <option value="">Seleccione un responsable</option>
                                                                    {
                                                                        instalacionesCliente?.map((instalaciones, index) => (
                                                                            instalaciones.informaciongeneralinstalacioncliente?.responsablesdeinstalacioncliente.map((opcion, index) => (
                                                                                <option value={`${opcion.idresponsabledeinstalacioncliente + '/' + opcion.nombreresponsable}`} >{`${instalaciones.informaciongeneralinstalacioncliente.instalacionnumero + '.-'}${instalaciones.idtipoanexo === 1 ? 'Unidad de producción: ' : instalaciones.idtipoanexo === 2 ? 'Unidad de envasado: ' : 'Unidad de Almacen: '}${opcion.nombreresponsable}`}</option>
                                                                            ))
                                                                        ))
                                                                    }
                                                                </select>
                                                                <label htmlFor='floatingInput'>Responsable de instalaciones</label>
                                                                <span className='text-danger'>{fc_33Map?.resposableinstalacionescheck === true ? fc_33Map?.resposableinstalaciones : ''}</span>
                                                                {touched.resposableinstalaciones && errors.resposableinstalaciones && <div className="text-danger">{errors.resposableinstalaciones}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-md-4'><br />
                                                            <div className="form-floating mb-3">
                                                                <input type="text" className={`form-control ${fc_33Map.correoelectronicocheck !== undefined ? (
                                                                    fc_33Map?.correoelectronicocheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                                    placeholder='correo'
                                                                    name="correoelectronico"
                                                                    value={values.correoelectronico}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <label htmlFor="floatingInput">Correo electrónico</label>
                                                                <br />
                                                                <span className='text-danger'>{fc_33Map?.correoelectronico}</span>
                                                                {touched.correoelectronico && errors.correoelectronico && <div className="text-danger">{errors.correoelectronico}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-md-2'><br />
                                                            <div className="form-floating mb-3">
                                                                <input type="number" min='0' className={`form-control ${fc_33Map.telefonocheck !== undefined ? (
                                                                    fc_33Map?.telefonocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Telefono'
                                                                    name="telefono"
                                                                    value={values.telefono}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur}
                                                                />
                                                                <label htmlFor="floatingInput">Teléfono</label>
                                                                <br />
                                                                <span className='text-danger'>{fc_33Map?.telefono}</span>
                                                                {touched.telefono && errors.telefono && <div className="text-danger">{errors.telefono}</div>}
                                                            </div>
                                                        </div>
                                                        <div className='col-md-12'>
                                                            <div className="form-floating mb-3">
                                                                <input type="text" className={`form-control ${fc_33Map.domicilioproductocheck !== undefined ? (
                                                                    fc_33Map?.domicilioproductocheck ? 'inputDenegado' : 'inputValidado') : ('')}`} id="floatingInput" placeholder='Calle'
                                                                    name="domicilioproducto"
                                                                    value={values.domicilioproducto}
                                                                    onChange={handleChange}
                                                                    onBlur={handleBlur} />
                                                                <label htmlFor="floatingInput">Domicilio completo</label>
                                                                <span className='text-danger'>{fc_33Map?.domicilioproducto}</span>
                                                                {touched.domicilioproducto && errors.domicilioproducto && <div className="text-danger">{errors.domicilioproducto}</div>}
                                                            </div>
                                                        </div>
                                                    </Fragment>
                                                }
                                            </div>
                                            <div className='row'>
                                                <h6 className={`text-center ${estilos.labelNaranja}`}>INFORMACIÓN ADICIONAL SOBRE LA ACTIVIDAD</h6>
                                            </div>
                                            <div className='col-md-12'>
                                                <br />
                                                <textarea type="textarea" rows="2" className={`form-control ${fc_33Map.informacionadicionalsobrecheck !== undefined ? (
                                                    fc_33Map?.informacionadicionalsobrecheck ? 'inputDenegado' : 'inputValidado') : ('')}`}
                                                    id="" placeholder='Especificar'
                                                    name="informacionadicionalsobreactivi"
                                                    value={values.informacionadicionalsobreactivi}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}

                                                />
                                                <span className='text-danger'>{fc_33Map?.informacionadicionalsobreactivi}</span>
                                                <br />
                                            </div>
                                        </Fragment>
                                    ) : paginaActiva === 2 ?
                                        (
                                            <Fragment>
                                                {
                                                    modoCorreccion &&
                                                    <div className='text-center'>
                                                        {
                                                            observacionesStatus.observacionesProductos !== 0 ?
                                                                <h6><p style={{ color: 'red' }}><strong>Este apartado tiene observaciones</strong></p></h6>
                                                                :
                                                                <h6><p style={{ color: 'green' }}><strong>Este apartado no tuvo observaciones</strong></p></h6>
                                                        }
                                                    </div>
                                                }
                                                <div className='row'>
                                                    <h6 className={`text-center ${estilos.labelNaranja}`}>CARACTERISTICAS DEL PRODUCTO</h6>
                                                </div>
                                                <div className='row align-items-center'>

                                                    <TablaProducto api={{ handdleProducto, handdleRemoveProductosPrev, handdleEditProductosPrev, productos }} marcas={marcas} productosMap={fc_33ProductosMap}></TablaProducto>
                                                    <div className='col-md-12'>
                                                        <label className="form-label"><b>NOTA:</b> Los productos en los que se agregue un ingrediente
                                                            durante el envasado deberan muestrearse posterior a su envasado para constatar el
                                                            cumplimiento con el apartado 4.3 de la NOM-070-SCFI-2016 a través del Informe de Resultados
                                                            de análisis fisicoquímico.</label>
                                                        <br />
                                                    </div>
                                                </div>
                                            </Fragment>
                                        ) :
                                        (
                                            <Fragment>
                                                {
                                                    modoCorreccion &&
                                                    <div className='text-center'>
                                                        {
                                                            observacionesStatus.observacionesFilesProductos !== 0 ?
                                                                <h6><p style={{ color: 'red' }}><strong>Este apartado tiene observaciones</strong></p></h6>
                                                                :
                                                                <h6><p style={{ color: 'green' }}><strong>Este apartado no tuvo observaciones</strong></p></h6>
                                                        }
                                                    </div>
                                                }
                                                {
                                                    modoCorreccion &&
                                                    <div className={`${estilos.componenteDocFC_33} col-md-12`}>

                                                        <DocumentacionFC_33Component> </DocumentacionFC_33Component>
                                                    </div>
                                                }
                                                <TerminosYCondicionesComponent terminosYCondiciones={terminosYCondiciones} formato={'fc_33'} />
                                                <br />
                                                <br />
                                                {
                                                    !modoCorreccion ?
                                                        <div>
                                                            <div className="row mt-4">
                                                                {
                                                                    modoEdicionBorrador ? (
                                                                        <div className="d-grid gap-2 col-2 mx-auto">
                                                                            <button type="submit"
                                                                                onClick={() => { botonEnviarSolicitudBorradorFC_33(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                                className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                                disabled={!terminosYCondiciones}>Enviar borrador</button>
                                                                        </div>
                                                                    ) : (
                                                                        <div className="d-grid gap-2 col-2 mx-auto">
                                                                            <button type="submit"
                                                                                onClick={() => { botonEnviarSolicitudFC_33(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                                className={`btn ${estilos.botonNaranjaRedondo}`}
                                                                                disabled={!terminosYCondiciones}>Enviar</button>
                                                                        </div>
                                                                    )
                                                                }

                                                            </div>
                                                        </div>
                                                        :
                                                        <div className="row mt-4">
                                                            <div className="d-grid gap-2 col-2 mx-auto">
                                                                <button type="submit"
                                                                    onClick={() => { botonEnviarCorreccionesFC_33(submitForm), setFunctionSubmitForm({ function: submitForm }), setFunctionResetForm({ function: resetForm }) }}
                                                                    className={`btn ${estilos.botonNaranjaRedondo}`}>Enviar correcciones</button>
                                                            </div>

                                                        </div>
                                                }

                                                <br />
                                            </Fragment>
                                        )
                            }
                            {modalComponent()}
                        </div ><br />
                        {validacion && <ModalCamposObligatorios texto={texto} api={{ resetValores }}></ModalCamposObligatorios>}
                        <BotonAtrasSiguienteComponent botonSiguiente={paginaSiguiente} botonAnterior={paginaAnterior} paginaActiva={paginaActiva} totalDePaginas={paginas.length} valores={values} />
                    </form>
                )}
            </Formik>
        </Fragment >
    )
}
export default withRouter(FormularioFC33BeneficiarioComponent)
